import { render, staticRenderFns } from "./FollowingProductionTasks.vue?vue&type=template&id=099429a4&scoped=true&"
import script from "./FollowingProductionTasks.vue?vue&type=script&lang=js&"
export * from "./FollowingProductionTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099429a4",
  null
  
)

export default component.exports